import importLocationsComponent from './location.import_locations.component';

let importLocationsModule = angular.module('importLocations', [])

.component('importLocations', importLocationsComponent)

.name;

export default importLocationsModule;




// WEBPACK FOOTER //
// ./client/app/components/location/import_locations/index.js